import React, { useState } from "react";
import { Flex, Box, Image, Button } from "@chakra-ui/react";
import { ExternalLinkIcon } from "@chakra-ui/icons";
import ecosystem from "../images/icon-ecosystem.svg";
import safu from "../images/icon-safu.svg";
import multi from "../images/icon-multichain.svg";
import community from "../images/icon-community.svg";
import gaming from "../images/icon-gaming.svg";
import partnership from "../images/icon-partnership.svg";
// import { ethers } from "ethers";

export function Selections() {
  const [opacityOne, setOpacityOne] = useState(1.0);
  const [opacityTwo, setOpacityTwo] = useState(0.25);
  const [opacityThree, setOpacityThree] = useState(0.25);
  const [opacityFour, setOpacityFour] = useState(0.25);
  const [opacityFive, setOpacityFive] = useState(0.25);
  const [opacitySix, setOpacitySix] = useState(0.25);
  const [item, setInfo] = useState(
    "Hyperjump has a whole ecosystem in one place. AMM, Farm, Staking, Vaults, Analytics, Permission Revoke Tool and Games."
  );

  /*   const [chainId, setChainId] = useState(250);

  useEffect(() => {
    async function getNetwork() {
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const { chainId } = await provider.getNetwork();
      setChainId(chainId);
    }

    getNetwork();
  }, [chainId]);
 */
  /*   const appLink =
    chainId && chainId === 56
      ? "https://bsc.hyperjump.app/"
      : "https://ftm.hyperjump.app/";
 */

  const handleOneClick = () => {
    setOpacityOne(1.0);
    setOpacityTwo(0.25);
    setOpacityThree(0.25);
    setOpacityFour(0.25);
    setOpacityFive(0.25);
    setOpacitySix(0.25);
    setInfo(
      "Hyperjump has a whole ecosystem in one place. AMM, Farm, Staking, Vaults, Analytics, Permission Revoke Tool and Games."
    );
  };

  const handleTwoClick = () => {
    setOpacityOne(0.25);
    setOpacityTwo(1.0);
    setOpacityThree(0.25);
    setOpacityFour(0.25);
    setOpacityFive(0.25);
    setOpacitySix(0.25);
    setInfo(
      "HyperJump is Audited by Certik. Hyperjump also have its own auditing services called HyperCheck. Hyperswap is safe from Flash-Loan Exploits. Hyperjump is the first project to patch syrup bug."
    );
  };

  const handleThreeClick = () => {
    setOpacityOne(0.25);
    setOpacityTwo(0.25);
    setOpacityThree(1.0);
    setOpacityFour(0.25);
    setOpacityFive(0.25);
    setOpacitySix(0.25);
    setInfo(
      "HyperJump is a MultiChain Project. We are live on Binance Smart Chain and Fantom Opera Chain. We will expand to more chains in the future."
    );
  };

  const handleFourClick = () => {
    setOpacityOne(0.25);
    setOpacityTwo(0.25);
    setOpacityThree(0.25);
    setOpacityFour(1.0);
    setOpacityFive(0.25);
    setOpacitySix(0.25);
    setInfo(
      "HyperJump is led by a DAO (Decentralized Autonomus Organization). Some community members are anonymous and some are doxxed."
    );
  };

  const handleFiveClick = () => {
    setOpacityOne(0.25);
    setOpacityTwo(0.25);
    setOpacityThree(0.25);
    setOpacityFour(0.25);
    setOpacityFive(1.0);
    setOpacitySix(0.25);
    setInfo(
      "HyperJump aims to combine gaming and decentralized finance together. We have launched a number of games and more will come in the future"
    );
  };

  const handleSixClick = () => {
    setOpacityOne(0.25);
    setOpacityTwo(0.25);
    setOpacityThree(0.25);
    setOpacityFour(0.25);
    setOpacityFive(0.25);
    setOpacitySix(1.0);
    setInfo(
      "HyperJump is a trusted project by both code and community. Multiple project have participated in ecosystem."
    );
  };

  return (
    <Flex className="selections">
      <Box className="listLinks">
        <Box
          as="button"
          className="listSelections"
          style={{ opacity: opacityOne }}
          onClick={handleOneClick}
        >
          <Image src={ecosystem} mr="15px" w="40px" />{" "}
          <p>
            <span className="listBlue">ALL-IN-ONE </span> ECOSYSTEM
          </p>
        </Box>

        <Box
          as="button"
          className="listSelections"
          style={{ opacity: opacityTwo }}
          onClick={handleTwoClick}
        >
          <Image src={safu} mr="15px" w="40px" />
          <p>
            HYPER-<span className="listBlueTwo">SAFU</span>
          </p>
        </Box>

        <Box
          as="button"
          className="listSelections"
          style={{ opacity: opacityThree }}
          onClick={handleThreeClick}
        >
          <Image src={multi} mr="15px" w="40px" />{" "}
          <p>
            <span className="listBlueTwo">MULTI-CHAIN </span> PROJECT
          </p>
        </Box>

        <Box
          as="button"
          className="listSelections"
          style={{ opacity: opacityFour }}
          onClick={handleFourClick}
        >
          <Image src={community} mr="15px" w="40px" />
          <p>
            COMMUNITY DRIVEN <span className="listBlueTwo">(DAO)</span>
          </p>
        </Box>

        <Box
          as="button"
          className="listSelections"
          style={{ opacity: opacityFive }}
          onClick={handleFiveClick}
        >
          <Image src={gaming} mr="15px" w="40px" />
          <p>
            GAMING RE<span className="listBlueTwo">DEFI</span>NED
          </p>
        </Box>

        <Box
          as="button"
          className="listSelections"
          style={{ opacity: opacitySix }}
          onClick={handleSixClick}
        >
          <Image src={partnership} mr="15px" w="40px" />
          <p>
            COUNTLESS <span className="listBlueThree">PARTNERSHIPS </span>
          </p>
        </Box>
      </Box>

      <Box className="panelInfo">
        <Box className="backSelections">
          <p className="textSelections"> {item} </p>
        </Box>

        <Box className=" botonesPanelInfo">
          <Button
            as="a"
            href="https://ftm.hyperjump.app/"
            target="_blank"
            colorScheme="blue"
            className="buttonLengend"
          >
            Launch dApps <ExternalLinkIcon w={6} h={6} m="0 0 4px 5px" />{" "}
          </Button>
          <Button
            as="a"
            href="https://docs.hyperjump.app/#/essentials/starmap"
            target="_blank"
            colorScheme="blue"
            className="buttonLengend"
          >
            What's coming next
          </Button>
        </Box>
      </Box>
    </Flex>
  );
}
